<mat-form-field class="width" [appearance]="appearance">

    <mat-label [ngClass]="{'setted': currentLocation}">
        {{currentLabel}}
    </mat-label>

    <input type="text" placeholder="Suchbegriff eingeben" matInput [matAutocomplete]="auto" [formControl]="filterControl" #inputField (keyup.enter)="setLocationIfOneLeft()" />

    <span class="suffix-wrapper" matSuffix>
        <button @fade [disabled]="filterControl.disabled || !currentLocation" mat-icon-button color="warn" (click)="selectLocation(null)"
            matTooltip='Wert leeren'>
            <mat-icon>clear</mat-icon>
        </button>
    </span>

    <mat-autocomplete #auto="matAutocomplete" #autocomplete (optionSelected)="selectLocation($event)">

        <mat-option class="custom-mat-option" [value]="location" *ngFor="let location of locations">
            {{display(location)|async}}
        </mat-option>

    </mat-autocomplete>

</mat-form-field>
